import { PropsWithChildren, useState } from 'react'
import styled from 'styled-components'
import { colors } from '../utils/config'
import { Icon } from '@bm-js/atlascloud-ui'
import { LucideIconName } from '@bm-js/atlascloud-shared'

const StyledRightBarGroup = styled.div`
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  position: relative;
  &:after {
    position: absolute;
    width: calc(100% + 1rem);
    height: 1px;
    background: ${colors.gray500};
    bottom: 0;
    left: -0.5rem;
    right: 0.5rem;
    content: '';
  }
  .right-bar-group-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .right-bar-group-content {
    transition: 200ms ease-in-out;
    overflow: hidden;
    max-height: 0;
  }
  &.group-expanded {
    .right-bar-group-content {
      margin-top: 1rem;
      max-height: 1200px;
      overflow-y: scroll;
    }
  }
  &.top-line {
    padding-top: 1rem;
    &:before {
      position: absolute;
      top: 0;
      left: -0.5rem;
      right: 0.5rem;
      width: calc(100% + 1rem);
      height: 1px;
      background: ${colors.gray500};
      content: '';
    }
  }
`

type Props = {
  title: string
  topLine?: boolean
}

const RightBarGroup = ({
  title,
  children,
  topLine,
}: PropsWithChildren<Props>) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <StyledRightBarGroup
      className={`${expanded ? 'group-expanded' : ''} ${
        topLine ? 'top-line' : ''
      }`}
    >
      <div className='right-bar-group-top'>
        <p className='primblue m0 xxs b'>{title}</p>
        <div
          onClick={() => setExpanded(!expanded)}
          className='pointer text-primary-400'
        >
          <Icon
            name={
              expanded ? LucideIconName.ChevronUp : LucideIconName.ChevronDown
            }
            className='size-5'
          />
        </div>
      </div>
      <div className='right-bar-group-content'>{children}</div>
    </StyledRightBarGroup>
  )
}

export default RightBarGroup
